module.exports = "/_next/static/images/proof-of-employment-5ec1b9c35ef524def7607aca89d6524c.svg";